import { render, staticRenderFns } from "./userSetting.vue?vue&type=template&id=960e754a&scoped=true&"
import script from "./userSetting.vue?vue&type=script&lang=ts&"
export * from "./userSetting.vue?vue&type=script&lang=ts&"
import style0 from "./userSetting.vue?vue&type=style&index=0&id=960e754a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960e754a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('960e754a')) {
      api.createRecord('960e754a', component.options)
    } else {
      api.reload('960e754a', component.options)
    }
    module.hot.accept("./userSetting.vue?vue&type=template&id=960e754a&scoped=true&", function () {
      api.rerender('960e754a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userSetting.vue"
export default component.exports